import Vue from 'vue';
import { Sketch } from 'vue-color'
Vue.component('chrome-picker',Sketch)